<template>
    <section class="video-embed light blue">
        <circles-layout></circles-layout>
        <ogt-video ref="video" src="/static/video/rap-studenten.mp4" :muted="false"></ogt-video>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import OgtVideo from '@/app/components/OgtVideo';
    import Circles from '@/app/components/circles';

    export default {
        name: 'MedewerkerVideo',
        meta: {
            title: 'MedewerkerVideo',
            color: '#36B1CA'
        },
        components: {
            'ogt-video': OgtVideo,
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            }
        }
    };
</script>
